import { Icon24CombineLarge } from '@figma/fpl-icons';
import { fplIcon } from './fplIcon';
import type { SvgComponent } from '@/types/SvgComponent';

const PromptConcatIconLocal: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M21.75 12L15 12L9.75 17.25L3.75 17.25"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.75 9L21.75 12L18.75 15"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75 6.75L9.75 6.75L15 12"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PromptConcatIconBase = fplIcon(PromptConcatIconLocal, Icon24CombineLarge);

export const PromptConcatIcon: SvgComponent = ({ style, ...props }) => (
  <PromptConcatIconBase {...props} style={{ ...style, transform: 'rotate(-90deg)' }} />
);
